module.exports = __webpack_public_path__ + "static/img/1.4789022.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/zh/1.png
// module id = CAL0
// module chunks = 0